/**
 * validateSocialInsuranceNumber - validates the sin input and performs checksum
 * @param {string} sin A string representation of the health card number
 * @returns {[boolean, string]} returns array with first element being isValid, second error string 
 */
export const validateSocialInsuranceNumberErrors = (sin) => {
    const regex = RegExp(/^[0-9]{9}$/i)

    if (!regex.test(sin)) {
        return 'errors.sin_error';
    }

    const algorithmNum = sin.slice(0, -1);
    const checkDigit = parseInt(sin.substr(-1));

    //From the rightmost digit (excluding the check digit) and moving left
    const arr = [...algorithmNum].reverse();
    const products = arr.map((character, index) => {
        //double the value of every second digit
        const num = parseInt(character);
        if (index % 2 === 0) {
            const product = num * 2;
            // If the result of this doubling operation is greater than 9 (e.g., 8 × 2 = 16),
            // then add the digits of the result (e.g., 16: 1 + 6 = 7, 18: 1 + 8 = 9) or,
            // equivalently, subtract 9 from the result
            return product > 9 ? product - 9 : product;
        }

        return num;
    });
    const sum = products.reduce((prevVal, currVal) => {
        return prevVal + currVal;
    }, 0);

    //Take the sum of all the digits (including the check digit).
    const totalSum = sum + checkDigit;

    //If the total modulo 10 is equal to 0 (if the total ends in zero) 
    // then the number is valid according to the Luhn formula; otherwise it is not valid.
    const isValid = totalSum % 10 === 0;
    return isValid ? false : 'errors.sin_invalid';
}